import React from "react"
import "./Description.css"

const Description = () => {
  return (
    <p className="description">A Sustainable Journey In Search Of Innovation</p>
  )
}
export default Description
